<h2 mat-dialog-title>{{ 'account.newTree' | t }}</h2>

<mat-dialog-content>
  <p class="hint">
    {{ 'account.treeIntro' | t }}
  </p>

  <mat-form-field appearance="outline" class="input">
    <mat-label>{{ 'account.treeName' | t }}</mat-label>
    <input matInput [formControl]="titleFormControl" maxlength="120"
      [placeholder]="'account.treeNamePlaceholder' | t" (input)="onTitleChange()" />
    @if (titleFormControl.hasError('required') && titleFormControl.touched) {
      <mat-error>{{ 'common.nameRequired' | t }}</mat-error>
    }
  </mat-form-field>

  <mat-form-field appearance="outline" class="input" floatLabel="always">
    <mat-label>{{ 'account.treeUrl' | t }}</mat-label>
    <span matTextPrefix>genealogy.cards/tree/&nbsp;</span>
    <input matInput [formControl]="urlFormControl" maxlength="50" placeholder="rod_kwiatkowskich" />
    <mat-hint>{{ 'account.treeUrlHint' | t }}</mat-hint>
    @if (urlFormControl.hasError('required') && urlFormControl.touched) {
      <mat-error>{{ 'common.addressRequired' | t }}</mat-error>
    }
    @if (urlFormControl.hasError('pattern')) {
      <mat-error>{{ 'description.urlError' | t }}</mat-error>
    }
  </mat-form-field>

  <div class="visibility">
    <h4>{{ 'visibility.title' | t }}</h4>
    <mat-radio-group [formControl]="visibilityFormControl" class="visibility-group">
      <mat-radio-button value="public">{{ 'visibility.public' | t }}</mat-radio-button>
      <span class="option-hint">{{ 'visibility.publicHint' | t }}</span>

      <mat-radio-button value="users">{{ 'visibility.users' | t }}</mat-radio-button>
      <span class="option-hint">{{ 'visibility.usersHint' | t }}</span>

      <mat-radio-button value="private">{{ 'visibility.private' | t }}</mat-radio-button>
      <span class="option-hint">{{ 'visibility.privateHint' | t }}</span>
    </mat-radio-group>
  </div>

  <!-- Kto ma plik z innego programu, nie powinien szukac importu w ustawieniach -->
  <div class="visibility">
    <h4>{{ 'account.startTitle' | t }}</h4>
    <mat-radio-group [formControl]="startFormControl" class="visibility-group">
      <mat-radio-button value="scratch">{{ 'account.startScratch' | t }}</mat-radio-button>
      <span class="option-hint">{{ 'account.startScratchHint' | t }}</span>

      <mat-radio-button value="gedcom">{{ 'account.startGedcom' | t }}</mat-radio-button>
      <span class="option-hint">{{ 'account.startGedcomHint' | t }}</span>
    </mat-radio-group>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="onCancelClick()">{{ 'common.cancel' | t }}</button>
  <button mat-flat-button color="primary" type="button" cdkFocusInitial
    [disabled]="treeForm.invalid || creating" (click)="onCreate()">{{ 'account.createTree' | t }}</button>
</mat-dialog-actions>
